import { Form } from "react-bootstrap";
import { ChangeEvent, useEffect, useState } from "react";
import { DownloadOptions } from "types";
import { BlueRadio, LightRadio } from "components/common";

interface Props {
    fastDisabled: boolean;
    selectedOption: DownloadOptions;
    onChange?: (option: DownloadOptions) => void;
    variant?: "light" | "dark";
}

export const DownloadOption = (props: Props) => {
    const {
        selectedOption,
        onChange,
        fastDisabled = false,
        variant = "light",
    } = props;
    const [downloadOption, setDownloadOption] =
        useState<DownloadOptions>("email");
    const [isFastDisabled, setIsFastDisabled] = useState(false);

    useEffect(() => {
        setDownloadOption(selectedOption);
    }, [selectedOption]);

    useEffect(() => {
        setIsFastDisabled(fastDisabled);
    }, [fastDisabled]);

    const onChangeOption = (e: ChangeEvent<HTMLInputElement>) => {
        const option = e.target.value as DownloadOptions;
        setDownloadOption(option);
        onChange?.(option);
    };

    const Radio = variant === "light" ? LightRadio : BlueRadio;

    return (
        <>
            <Form.Label
                className={`${
                    variant === "light" ? "text-primary-blue-3" : ""
                }`}
            >
                Download Options
            </Form.Label>
            <Form.Group
                className={`${
                    variant === "light" ? "text-primary-blue-3" : ""
                } mb-3 `}
            >
                <Radio
                    className="mr-4 mt-2"
                    value="email"
                    inline
                    type="radio"
                    custom
                    id={`download-email`}
                    checked={downloadOption === "email"}
                    name="download-option"
                    label={<span className="ml-1">Receive Link</span>}
                    onChange={onChangeOption}
                />

                <Radio
                    className="mt-2"
                    value="fast"
                    inline
                    type="radio"
                    custom
                    id={`download-fast`}
                    checked={downloadOption === "fast"}
                    name="download-option"
                    label={
                        <span className="ml-1">
                            Fast Download (Ranges up to 24 hours)
                        </span>
                    }
                    onChange={onChangeOption}
                    disabled={isFastDisabled}
                />
            </Form.Group>
        </>
    );
};
